import { useSearchParams } from "react-router-dom";
import {
  GarageDoorInstallationInformation,
  GarageDoorMeasurementValues,
} from "./components";
import "./garage-door-form.scss";

interface GarageDoorFormType {
  setStep: (page: number) => void;
  step: number;
  measurementInfo: any;
  prevStep: () => void;
}

const GarageDoorForm = ({
  step,
  setStep,
  measurementInfo,
  prevStep,
}: GarageDoorFormType) => {
  const [searchParams] = useSearchParams();
  const measurementUuid = searchParams.get("measurementUuid");

  const handleShowForm = (step: number, measurementUuid: string | null) => {
    switch (step) {
      case 2:
        return (
          <GarageDoorInstallationInformation
            setStep={setStep}
            step={step}
            measurementInfo={measurementInfo}
            measurementUuid={measurementUuid}
            prevStep={prevStep}
          />
        );
      case 3:
        return (
          <GarageDoorMeasurementValues
            setStep={setStep}
            step={step}
            measurementUuid={measurementUuid}
            prevStep={prevStep}
          />
        );
      default:
        return <p>default</p>;
    }
  };

  return handleShowForm(step, measurementUuid);
};

export default GarageDoorForm;
